import React, {Fragment} from "react";
import {webbased, freeAccess, easyToUse} from "./HomeCardSVG";
import HomeCardsCSS from "./HomeCards.module.scss";

const data = [
  {
    title: "Web Based",
    icon: webbased(),
  },
  {
    title: "Free Access",
    icon: freeAccess(),
  },
  {
    title: "Easy To Use",
    icon: easyToUse(),
  },
];
const HomeCards = () => {
  return (
    <Fragment>
      <div className={`${HomeCardsCSS.HomeCards}`}>
        <div className={`container ${HomeCardsCSS.HomeCardWrapper}`}>
          {data.map((ele, index) => {
            const {icon, title} = ele;
            return (
              <div className={HomeCardsCSS.HomeCard} key={index}>
                <div className={HomeCardsCSS.HomeCardIcon}>{icon}</div>
                <div className={HomeCardsCSS.HomeCardContent}>
                  <h4>{title}</h4>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </Fragment>
  );
};

export default HomeCards;
